import { track } from "../analytics";

/**
 * The vault's three client events, closed here so no call site can widen a prop into a
 * filename or a clip key. The server owns the landings (vault_upload_received,
 * vault_upload_deleted, vault_expanded) and the spend (faps_spent{kind:"vault"}); the
 * client reports only the attempt, the refusal, and the tap that answers it.
 */
export const trackVaultUploadStarted = (bytes: number): void =>
  track("vault_upload_started", { bytes });
export const trackVaultQuotaHit = (): void => track("vault_quota_hit", {});
export const trackVaultExpandClicked = (): void => track("vault_expand_clicked", {});

/** The panel on screen — once per page load, the way the Gold rows report (a re-render
 *  is not a second look). Carries the fill level of whoever is looking. */
let openedOnce = false;
export function trackVaultOpened(v: { usedBytes: number; maxBytes: number; items: number }): void {
  if (openedOnce) return;
  openedOnce = true;
  track("vault_opened", { usedBytes: v.usedBytes, maxBytes: v.maxBytes, items: v.items });
}
/** Your Uploads put on a screen, from the collection's own Play or the picker's row. */
export const trackVaultPlayed = (via: "collection" | "picker"): void => track("vault_played", { via });
